export default "__VITE_ASSET__CAcS$Sg1__"